<section class="spen-ly-section lv-2 back-button">
  <button class="spen-mod-btn" (click)="back()">戻る</button>
</section>
